import { memo, useContext } from 'react';
import { AnimationContainer } from '@/sub-luca-plugin/compatible-components';
import { QaRecordsContext } from '../../helper';

const TeacherQaTips = ({ date }: { date: string }) => {
    const { getQaStoreByContext } = useContext(QaRecordsContext);

    return (
        <AnimationContainer type="fade_in" canExcuteAimation={getQaStoreByContext()?.qaConfig.canExcuteAimation}>
            <div className="teacher-qa-tips-date">{date}</div>
            <div className="teacher-qa-tips">
                <div className="teacher-qa-tips__title">名师答疑</div>
                <div className="teacher-qa-tips__text">该问题已转至名师回复</div>
            </div>
        </AnimationContainer>
    );
};

export default memo(TeacherQaTips);
